import styled from 'styled-components';

export const Container = styled.div<{ $asMobileApp?: boolean; $hasDividerFlair?: boolean; $isCompact?: boolean }>`
  min-height: ${({ $isCompact }) => ($isCompact ? 'auto' : '420px')};
  padding: 5px 16px;
  border-bottom: ${({ $asMobileApp }) => ($asMobileApp ? 'none' : '1px solid #d7e4eb')};
  margin-bottom: ${({ $asMobileApp }) => ($asMobileApp ? '0' : '35px')};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  align-items: center;
`;

export const Title = styled.h2<{ $hasDividerFlair?: boolean }>`
  color: ${({ $hasDividerFlair, theme }) => ($hasDividerFlair || theme?.isBackgroundDark ? '#fff' : '#242526')};
  font-weight: bold;
  font-size: 20px;

  > svg {
    margin-left: 8px;
  }
`;

export const ViewAllLink = styled.a`
  color: ${({ theme }) => theme.linkColor};
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  text-transform: ${({ theme }) => theme.textTransforms.links};
`;

export const CardsContainer = styled.div<{ $isProductCardsV2Enabled?: boolean }>`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(
    auto-fill,
    ${({ $isProductCardsV2Enabled }) => ($isProductCardsV2Enabled ? '184px' : '160px')}
  );
  grid-gap: 11px;
  margin-top: 15px;
  padding: 10px 0 18px 0;
  margin-left: -30px;
  padding-left: 30px;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
`;

export const GridCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 15px;
  padding: 10px 0 18px 0;
`;
